import _ = require("underscore");

type TExtreme = {
    label: string,
    value: number
};

type TAxis = {
    min: TExtreme,
    max: TExtreme
}

export type TPlotDefinition = {
    x: TAxis,
    y: TAxis,
    grid: {
        step: number|null
        ticks: boolean
    },
}

export default class PlotDefinition {

    private static DEFAULT_DEFINITION: TPlotDefinition = {
        x: {
            min: {label: '', value: -100},
            max: {label: '', value: 100},
        },
        y: {
            min: {label: '', value: -100},
            max: {label: '', value: 100},
        },
        grid: {
            step: null,
            ticks: false,
        },
    }

    private readonly definition: TPlotDefinition;

    constructor(definition?: Partial<TPlotDefinition>) {
        this.definition = _.extend(PlotDefinition.DEFAULT_DEFINITION, definition)
    }

    get x(): TAxis {
        return this.definition.x;
    }

    get y(): TAxis {
        return this.definition.y;
    }

    get gridStep(): number|null {
        const step = this.definition.grid.step;
        if (typeof step === 'number' && (
            step > (this.x.max.value - this.x.min.value)/2 ||
            step > (this.y.max.value - this.y.min.value)/2
        )) {
            return null;
        }
        return step;
    }

    get ticks(): boolean {
        return this.definition.grid.ticks;
    }
}
